import { render } from "./HeadIndex.vue?vue&type=template&id=4766cdca&scoped=true"
import script from "./HeadIndex.vue?vue&type=script&lang=js"
export * from "./HeadIndex.vue?vue&type=script&lang=js"

import "./HeadIndex.vue?vue&type=style&index=0&id=4766cdca&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4766cdca"]])

export default __exports__